/*
 * Sticky Buybox
 *
 * Die Infospalte der Produktseite ist meist höher als der Viewport. Mit einem
 * festen `top` würde sie sofort oben andocken und das untere Ende (inkl.
 * "In den Warenkorb") wäre nie sichtbar.
 *
 * Deshalb wird `top` hier dynamisch berechnet: Ist die Spalte höher als der
 * verfügbare Platz, bekommt sie einen negativen Offset. Sie scrollt dann so
 * lange mit, bis ihr unteres Ende am Viewport-Boden angekommen ist, und bleibt
 * ab da stehen, während die Bilder links weiterlaufen.
 */
(() => {
  const BREAKPOINT = 750; // muss zum Media-Query in section-main-product.css passen
  const TOP_OFFSET = 103; // Höhe des fixierten Headers
  const BOTTOM_GAP = 24;

  const columns = new Set();
  let frame = null;

  function measure(el) {
    if (window.innerWidth < BREAKPOINT) {
      el.style.removeProperty('--sticky-info-top');
      return;
    }

    const height = el.offsetHeight;
    const available = window.innerHeight - TOP_OFFSET - BOTTOM_GAP;
    const top = height <= available ? TOP_OFFSET : window.innerHeight - height - BOTTOM_GAP;

    el.style.setProperty('--sticky-info-top', `${Math.round(top)}px`);
  }

  function update() {
    frame = null;
    columns.forEach(measure);
  }

  function scheduleUpdate() {
    if (frame !== null) return;
    frame = requestAnimationFrame(update);
  }

  const resizeObserver =
    'ResizeObserver' in window ? new ResizeObserver(scheduleUpdate) : null;

  function register(el) {
    if (columns.has(el)) return;
    columns.add(el);
    resizeObserver?.observe(el);
    measure(el);
  }

  function scan(root = document) {
    root.querySelectorAll?.('.product__column-sticky').forEach(register);
  }

  scan();
  document.addEventListener('DOMContentLoaded', () => scan());
  window.addEventListener('load', scheduleUpdate);
  window.addEventListener('resize', scheduleUpdate);

  // product-info.js tauscht bei Variantenwechsel Teile der Spalte aus, das
  // Bundle-Picker-UI klappt Felder auf und zu – beides ändert die Höhe.
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.classList?.contains('product__column-sticky')) register(node);
        else scan(node);
      }
    }
    scheduleUpdate();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
